<template>
  <div v-if="options">
    <VueFileAgent v-model="file"
                  :disabled="disabled"
                  deletable
                  :multiple="false"
                  :uploadUrl="false"
                  :helpText="options.helpText"
                  :accept="options.accept"
                  :maxSize="options.maxSize"
                  :linkable="true"
                  theme="list"
                  :errorText="{type: options.typeError,size: options.sizeError}"
                  @select="fileSelected($event)"
                  @beforedelete="onBeforeFileDelete($event)"/>
    <span class="text-muted font-size-10">{{ options.acceptText }}</span>
  </div>
</template>

<script>
export default {
  name: "FileUpload",
  props: ['initial', 'options', 'disabled', 'type'],
  data() {
    return {
      file: null,
      cache: {}
    }
  },
  methods: {
    fileSelected(newFileSelected) {
      this.file = newFileSelected.map(function(fileRecord) {
        return {
          file: fileRecord.file
        };
      });
      this.cache[this.type] = this.file
      this.$emit('file', this.file)
    },
    onBeforeFileDelete() {
      this.file = []
      this.$emit('file', null)
    },
  },
  watch: {
    type(val) {
      this.file =  this.cache[val] ? this.cache[val] : null
      this.$emit('file', this.file)
    },
    initial(newVal) {
      this.file = [newVal]
    }
  }
}
</script>

<style scoped>

</style>